import { NavLink } from 'react-router-dom';
import { COMMAND_MODULES } from '../lib/constants';

interface CommandSidebarProps {
  onLogout: () => void;
}

export default function CommandSidebar({ onLogout }: CommandSidebarProps) {
  return (
    <aside className="hidden md:flex md:w-64 shrink-0 bg-[#1F2329] text-white flex-col sticky top-0 h-screen">
      <div className="px-5 py-5 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 flex items-center justify-center bg-[#E8610A] text-white rounded-lg">
            <i className="ri-command-line text-lg"></i>
          </div>
          <div>
            <h1 className="font-bold text-sm leading-tight">HomeOffice Premium</h1>
            <p className="text-[11px] text-white/50">Centro de Comando</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {COMMAND_MODULES.map((m) => (
          <NavLink
            key={m.to}
            to={m.to}
            end={m.end}
            className={({ isActive }) =>
              `w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-150 whitespace-nowrap cursor-pointer ${
                isActive
                  ? 'bg-[#E8610A] text-white'
                  : 'text-white/60 hover:bg-white/5 hover:text-white'
              }`
            }
          >
            <i className={`${m.icon} text-base`}></i>
            {m.label}
          </NavLink>
        ))}
      </nav>

      <div className="px-3 py-4 border-t border-white/10">
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-white/60 hover:bg-white/5 hover:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-logout-box-r-line text-base"></i>
          Sair
        </button>
      </div>
    </aside>
  );
}